<template>
  <div>
    <v-row no-gutters>
      <v-col cols="6" class="margin-auto">
        <h2 class="margin-auto color-custom-blue font-weight-600">
          Opportunities
        </h2>
      </v-col>
      <v-col cols="6">
        <span>
          <template>
            <span class="float-right">
              <v-skeleton-loader
                class="custom-skeleton d-inline-block custom-skeleton-full-width"
                v-if="pageLoading"
                type="button"
                height="28"
                width="200"
              >
              </v-skeleton-loader>
              <v-btn
                depressed
                v-else
                class="mx-2 mr-4 custom-bold-button white--text"
                color="cyan"
                small
                v-on:click.native.stop="createOpportunity"
              >
                <v-icon dark left>mdi-plus</v-icon>Create Opportunity
              </v-btn>
            </span>
          </template>
        </span>
      </v-col>
    </v-row>
    <v-row class="customer-detail custom-border-to">
      <v-col md="12" sm="12" class="pt-0">
        <v-skeleton-loader
          class="custom-skeleton"
          v-if="pageLoading"
          type="table-tbody"
        ></v-skeleton-loader>
        <ListingTable
          v-else
          :columnCount="8"
          :dataLoading="dataLoading"
          :rowData="dataRows"
        >
          <template v-slot:thead>
            <thead>
              <tr>
                <th class="simple-table-th" width="100">Opportunity #</th>
                <th class="simple-table-th" width="100">Title</th>
                <th class="simple-table-th" width="100">Source</th>
                <th class="simple-table-th" width="200">Opportunity</th>
                <th class="simple-table-th" width="100">Amount</th>
                <th class="simple-table-th" width="100">Total Amount</th>
                <th class="simple-table-th" width="100">Status</th>
                <th class="simple-table-th" width="200">Date</th>
              </tr>
            </thead>
          </template>
          <template v-slot:tbody>
            <tbody class="custom-border-bottom custom-border-top">
              <template v-if="dataRows.length > 0">
                <tr
                  link
                  :key="index"
                  v-for="(row, index) in dataRows"
                  v-on:click="
                    $router.push(
                      getDefaultRoute('opportunity.detail', {
                        params: { id: row.id },
                      })
                    )
                  "
                  class="alternate-listing-row"
                >
                  <td class="simple-table-td">
                    <Barcode
                      route="opportunity.detail"
                      :barcode="row.barcode"
                      :id="row.id"
                    ></Barcode>
                  </td>
                  <td class="simple-table-td">
                    <div class="quotation-listing-customer">
                      <p class="m-0 custom-nowrap-ellipsis d-flex">
                        <!-- <b>Title: </b> -->
                        <read-more
                          class="custom-read-more"
                          more-str="read more"
                          :text="row?.title || '<em>No title</em>'"
                          link="#"
                          less-str="read less"
                          :max-chars="35"
                        >
                        </read-more>
                      </p>
                    </div>
                  </td>
                  <td class="simple-table-td">
                    <div class="quotation-listing-customer">
                      <p class="m-0 custom-nowrap-ellipsis">
                        <!-- <b>Sales representative: </b> -->
                        <template v-if="row.source">
                          <v-chip small class="mb-1 mr-1">
                            <span>{{ row.source }}</span>
                          </v-chip>
                        </template>
                        <template v-else
                          ><em class="text--secondary">No Source</em></template
                        >
                      </p>
                    </div>
                  </td>
                  <td class="simple-table-td">
                    <template v-if="row && row.opportunity_text">
                      {{ row.opportunity_text }}
                    </template>
                    <em v-else class="text-muted"> no opportunity</em>
                  </td>
                  <td class="simple-table-td" width="100">
                    <div class="quotation-listing-amount">
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b>Sub Total: </b>
                        {{ $accountingJS.formatMoney(row.sub_total) }}
                      </p>
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b>Tax: </b>
                        {{ $accountingJS.formatMoney(row.tax_amount) }}
                      </p>
                    </div>
                  </td>
                  <td class="simple-table-td" width="100">
                    <div class="quotation-listing-amount px-3">
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b class="font-size-16 font-weight-600">Total: </b>
                        {{ $accountingJS.formatMoney(row.total) }}
                      </p>
                    </div>
                  </td>
                  <td class="simple-table-td" width="100">
                    <CustomStatus
                      small
                      :status="row.status"
                      endpoint="quotation/status"
                    >
                    </CustomStatus>
                  </td>
                  <td class="simple-table-td">
                    <template v-if="row && row.opportunity_date">
                      {{ row.opportunity_date }}
                    </template>
                    <em v-else class="text-muted"> no opportunity date</em>
                  </td>
                  <!-- <td class="simple-table-td" width="200">
                    <div class="quotation-listing-customer">
                      <p class="m-0 custom-nowrap-ellipsis" v-if="row.date">
                        <b>Created: </b> {{ formatDate(row.date) }}
                      </p>
                      <p
                        class="m-0 custom-nowrap-ellipsis"
                        v-if="row.open_till"
                      >
                        <b>Validity: </b> {{ getValidityDate(row) }}({{
                          row.validity_till
                        }}Days)
                      </p>
                      <p
                        class="m-0 custom-nowrap-ellipsis"
                        v-if="row.sent_date"
                      >
                        <b>Sent: </b> {{ formatDate(row.sent_date) }}
                      </p>
                    </div>
                  </td> -->
                </tr>
              </template>
              <tr v-else-if="!dataLoading">
                <td colspan="8">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no opportunity at the moment.
                  </p>
                </td>
              </tr>
            </tbody>
          </template>
        </ListingTable>
      </v-col>
    </v-row>
    <PersonSelectOpportunity
      :dialog="contactDialog"
      v-on:close="contactDialog = false"
      :parentId="parentDetails.id"
      :type="'customer'"
      @select="selectContactPerson"
    />
  </div>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { QUERY } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import moment from "moment";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import PersonSelectOpportunity from "@/view/components/PersonSelectOpportunity.vue";

export default {
  name: "opportunities",
  title: "Lead",
  mixins: [CommonMixin],
  components: { Barcode, ListingTable, CustomStatus, PersonSelectOpportunity },
  props: {
    type: {
      type: String,
      required: true,
      default: "lead",
    },
    parentDetails: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dataRows: [],
      pageLoading: false,
      dataLoading: true,
      contactDialog: false,
      filter: {
        status: "all",
        search: null,
      },
    };
  },
  watch: {
    parentDetails: {
      deep: true,
      handler() {
        if (this.parentDetails && this.parentDetails.id) {
          this.getrows();
        }
      },
    },
  },
  methods: {
    createOpportunity() {
      this.contactDialog = true;
    },
    selectContactPerson(person) {
      this.contactDialog = false;
      let queryData = {
        customer: this.parentDetails.id,
        person: person.id,
        type: "customer",
      };
      this.$router.push(
        this.getDefaultRoute("opportunity.create", {
          query: queryData,
        })
      );
    },
    getrows() {
      const _this = this;

      if (!_this.parentDetails || !_this.parentDetails.id) {
        return;
      }

      let filter = {
        per_page: 10,
        current_page: 1,
        status: _this.filter.status || "all",
        search: _this.filter.search || undefined,
        dates: _this.dates || undefined,
        type: _this.type,
        type_id: _this.parent,
        customer_id: _this.parentDetails.id,
      };
      if (_this.lodash.isEmpty(_this.dates) === false) {
        if (moment(_this.dates[0]).isAfter(_this.dates[1])) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("End Date must be after Start Date.")
          );
          return false;
        }
      } else {
        filter.dates = undefined;
      }

      clearTimeout(_this.timeout);
      _this.dataRows = [];
      _this.dataLoading = true;
      _this.timeout = setTimeout(function () {
        _this.$store
          .dispatch(QUERY, {
            url: "opportunities",
            data: filter,
          })
          .then(({ data }) => {
            _this.dataRows = data.rows;
            _this.statusList = data.status_list;
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.dataLoading = false;
          });
      }, _this.timeoutLimit);
    },
  },
  computed: {},
  mounted() {
    const _this = this;
    _this.getrows();

    console.log({ parentDetails: _this.parentDetails, type: _this.type });
  },
  beforeDestroy() {
    /*this.$root.$off("clearSelection");*/
  },
};
</script>
